import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface SalesforceConfig {
  salesforceId: string | null;
}

export const putSalesforceId = ({
  businessId,
  salesforceId,
}: {
  businessId: number;
  salesforceId: string | null;
}): AxiosPromise<void> => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/businesses/${businessId}/integrations/salesforce`,
    data: {
      salesforceId,
    },
  });
};
